import React, { useState, useEffect, useCallback } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { addDateFilter } from "../store/app";
import "react-datepicker/dist/react-datepicker.css";
import ro from "date-fns/locale/ro";
import t from "babel-plugin-yate/macro";
import { useParams } from "react-router-dom";

import "../../src/styles/_range-of-days.css";

registerLocale("ro", ro);

const currentDate = new Date();
const nDaysAgo = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  currentDate.getDate() - 13,
);

export function RangeOfDays() {
  const { lendingType } = useParams();
  const locationId = useSelector((state) => state.auth.locationId);
  const [startDate, setStartDate] = useState(nDaysAgo);
  const [endDate, setEndDate] = useState(currentDate);
  const [isRangeDefault, setIsRangeDefault] = useState();
  const dispatch = useDispatch();

  const resetInputs = useCallback(() => {
    setStartDate(nDaysAgo);
    setEndDate(currentDate);
    setIsRangeDefault(true);
  }, []);

  useEffect(() => {
    resetInputs();
  }, [resetInputs, locationId, lendingType]);

  useEffect(() => {
    if ((startDate && endDate) || (startDate === null && endDate === null)) {
      dispatch(addDateFilter({ startDate, endDate }));
    }
  }, [dispatch, startDate, endDate]);

  return (
    <div className="inline-block relative pl-4 pr-8 border rounded border-grey-3">
      <DatePicker
        locale="ro"
        dateFormat="dd.MM.yyyy"
        selected={startDate}
        onChange={(date) => {
          setStartDate(date);
          setIsRangeDefault(false);
        }}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        maxDate={new Date()}
        placeholderText={t`DD.MM.YYYY`}
      />

      <svg
        className="dates-range__arrow"
        focusable="false"
        viewBox="0 0 1000 1000"
      >
        <path d="M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z" />
      </svg>

      <DatePicker
        locale="ro"
        dateFormat="dd.MM.yyyy"
        selected={endDate}
        onChange={(date) => {
          setEndDate(date);
          setIsRangeDefault(false);
        }}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        maxDate={new Date()}
        placeholderText={t`DD.MM.YYYY`}
      />

      {!isRangeDefault && startDate && endDate && (
        <button
          type="button"
          className="react-datepicker__clear"
          aria-label="Clear time interval inputs"
          onClick={resetInputs}
        >
          <svg
            className="react-datepicker__clear-icon"
            focusable="false"
            viewBox="0 0 12 12"
          >
            <path
              fillRule="evenodd"
              d="M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
